import React, {useEffect} from 'react';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { styled } from '@mui/material/styles';
import TableCell, {tableCellClasses} from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import moment from "moment/moment";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import firebase from "../../firebase/firebase";
import MenuItem from "@mui/material/MenuItem";
import {Select} from "@mui/material";
import InputBase from '@mui/material/InputBase';
import {useNavigate} from "react-router-dom";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import SearchIcon from '@mui/icons-material/Search';
import InputComponent from "../../components/input-component";
export default function UserList(){
  const navigator = useNavigate()
  const [users, setUsers] = React.useState([]);
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: 'none',
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: '#F1F4F8',
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));
  const [filter, setFilter] = React.useState('artist')
  const [memberFilter, setMemberFilter] = React.useState('-')
  const [filterData, setFilterData] = React.useState([])
  const [searchValue, setSearchValue] = React.useState('')

  const BootstrapInput = styled(InputBase)(({ theme }) => ({
    'label + &': {
      marginTop: theme.spacing(3),
    },
    '& .MuiInputBase-input': {
      borderRadius: 30,
      position: 'relative',
      backgroundColor: '#204488',
      border: 'none',
      fontSize: 16,
      width: 'auto',
      color: '#fff',
      padding: '10px 26px 10px 20px',
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      '&:focus': {
        borderRadius: 30,
        borderColor: 'none',
        boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
      },
    },
  }));

  const search = (value) => {

    if (value === '') {
      setFilterData([...users])
    } else {
      const regex = new RegExp(value.toUpperCase());
      setFilterData(users.filter((u) => regex?.test(u.name.toLowerCase()) || regex?.test(u.email.toLowerCase())));
    }
  }
  const membershipFilter = (value) => {

    if (value === '-') {
      setFilterData([...users])
    } else {
      setFilterData(users.filter((u) => u.membership && u?.membership?.package === value));
    }
  }

  useEffect(() => {
    let projectRef = firebase
      .firestore()
      .collection('users')
      .orderBy('createdAt', 'desc')
      .where('userType', '==', filter)

      .get()
      .then((snapshots) => {
        setFilterData(snapshots?.size > 0 ? snapshots.docs.map((user) => ({id: user?.id, ...user.data()})) : []);
        setUsers(snapshots?.size > 0 ? snapshots.docs.map((user) => ({id: user?.id, ...user.data()})) : []);
      })

  }, [filter]);
  return (
    <Container maxWidth={'full-width'}  sx={{height: 'calc(100vh - 120px)', p: 5, textAlign: 'left', overflowY: 'scroll'}}>
      <Stack direction={'column'} spacing={5}>
        <Stack direction={'row'} spacing={3}  justifyContent="flex-start"
               alignItems="center">
          <Typography variant={'h4'} color={'primary'}>User</Typography>
          <Typography variant={'h4'} color={'primary'}>></Typography>
          <Typography variant={'h4'} color={'primary'}>
            User List
          </Typography>

          <Select value={filter} multiple={false} style={{color:"white",borderRadius:"30px",backgroundColor:"#204488",width:"195px",paddingLeft:"10px",paddingRight:"10px",height:"50px"}}
           IconComponent={() => <ArrowDropDownIcon  />}  onChange={(e) => {
            setFilter(e.target.value)
          }}>
            <MenuItem value={'artist'}>
              Artist
            </MenuItem>
            <MenuItem value={'investor'}>
              Investor
            </MenuItem>
            <MenuItem value={'creator'}>
              Creator
            </MenuItem>
          </Select>
          <Select value={memberFilter} multiple={false}
           style={{color:"white",borderRadius:"30px",backgroundColor:"#204488",paddingLeft:"10px",paddingRight:"10px",width:"195px",height:"50px"}}
           IconComponent={() => <ArrowDropDownIcon  />}
          onChange={(e) => {
            setMemberFilter(e.target.value)
            membershipFilter(e.target.value)
          }}>
            <MenuItem  value={'-'}>
              Membership
            </MenuItem>
            <MenuItem value={'TAOST BASIC'}>
              Taost basic
            </MenuItem>
            <MenuItem value={'TAOST PRO'}>
              Taost Pro
            </MenuItem>
          </Select>
          <Box sx={{flex: 1}}/>
          <Stack direction='row'  justifyContent="center"
                 alignItems="center">
            <InputComponent value={searchValue}  callback={ (value) => {
              search(value)
            }}/>
          </Stack>
        </Stack>

        <TableContainer >
          <Table sx={{ minWidth: 700 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <StyledTableCell  sx={{fontWeight: 'bolder', fontSize:16, }}>Name</StyledTableCell>
                <StyledTableCell align="center" sx={{fontWeight: 'bolder', fontSize:16, }}>Email</StyledTableCell>
                <StyledTableCell align="center" sx={{fontWeight: 'bolder', fontSize:16, }}>User type</StyledTableCell>
                <StyledTableCell align="center" sx={{fontWeight: 'bolder', fontSize:16, }}>Join date</StyledTableCell>
                <StyledTableCell align="center" sx={{fontWeight: 'bolder', fontSize:16, }}>Membership</StyledTableCell>
                {/* <StyledTableCell align="center" sx={{fontWeight: 'bolder', fontSize:16, }}>Location</StyledTableCell> */}
                <StyledTableCell align="center" sx={{fontWeight: 'bolder', fontSize:16, }}>Details</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filterData.length > 0
                && filterData.map((row, i) => (
                  <StyledTableRow
                    key={row.id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <StyledTableCell  component="th" scope="row">
                      <Typography noWrap={true} sx={{maxWidth: 150}}>
                        {row?.name || row?.uid}
                      </Typography>
                    </StyledTableCell>
                    <StyledTableCell align="center"><Typography noWrap={true}>{row?.email}</Typography></StyledTableCell>
                    <StyledTableCell align="center"><Typography sx={{textTransform:"capitalize"}} noWrap={true}>{row?.userType}</Typography></StyledTableCell>
                    <StyledTableCell align="center"><Typography>
                      {row?.createdAt && moment(row?.createdAt.seconds*1000).format('MM/DD/YYYY') }
                    </Typography></StyledTableCell>
                    <StyledTableCell align="center"><Typography>
                      {row.membership ? row?.membership?.package : 'None'}
                    </Typography></StyledTableCell>
                    {/* <StyledTableCell align="center">

                      <Typography>{row?.country || 'USA'}</Typography>
                    </StyledTableCell> */}
                    <StyledTableCell align="center">
                      <Button variant={'text'} sx={{textDecoration: 'underline'}} 
                      onClick={() => row?.userType === 'creator' ? navigator('/admin/user-list-creator', {state: {user: row}}) :
                      row?.userType === 'investor'? navigator('/admin/user-list-investor', {state: {user: row}}) : 
                      navigator('/admin/user-list-artist', {state: {user: row}})}>
                        View
                      </Button>
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

      </Stack>
    </Container>
  )
}